@if (loading()) {
  <div class="loading-overlay">
    <mat-spinner></mat-spinner>
  </div>
}
<mat-toolbar>

  <span class="spacer"></span>

  <a mat-flat-button
     routerLink="../../chat"
     aria-label="Open Settings dialog"
  >
    <mat-icon>tune</mat-icon>
    <span>Back to Chat</span>
  </a>
</mat-toolbar>


<mat-form-field class="full-width">
  <mat-label>Search</mat-label>
  @if (query) {
    <button class="clear-btn" matPrefix mat-icon-button aria-label="Clear" (click)="query=''">
      <mat-icon>close</mat-icon>
    </button>
  }
  <input matInput
         [disabled]="loading()"
         [(ngModel)]="query"
         (keyup.enter)="queryEmbeddingAugmentor()"
         placeholder="Paper Title">
  @if (query) {
    <button class="clear-btn" matSuffix mat-icon-button aria-label="Clear" (click)="queryEmbeddingAugmentor()">
      <mat-icon>send</mat-icon>
    </button>
  }
</mat-form-field>

@if (paperAugmentorResults(); as augmentorResults) {
  @if(augmentorResults.length > 0){
    <h2>Query: {{passedQuery}}</h2>
  }
  <div class="result-list">
    @for (augmentorResult of augmentorResults; track $index) {
      <app-paper-embedding-paper-card [embeddingResult]="augmentorResult"
                                      [projectId]="project()!.id"></app-paper-embedding-paper-card>
    }
  </div>
} @else {
  <p class="start-hint">Start you embedding search</p>
}
